import { signUp } from "@/services/auth";
import { useAppStore } from "@/store/app";
import { useCallback, useEffect, useState } from "react";
import { Button } from "../ui/button";

import logo from "@/assets/img/logo-login.svg";
import selo from "@/assets/img/footer-adesivo.svg";
import bgFlowerLeft from "@/assets/img/bg-flower-left.svg";
import bgFlowerRight from "@/assets/img/bg-flower-right.svg";
import { validateCPF } from "@/lib/utils";

export default function SignUpForm() {
  const { login, logout, restoreSession } = useAppStore();

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState<any>();
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(
    async (e: React.FormEvent) => {
      e.preventDefault();
      try {
        console.log(username, email);
        if (!username || !validateCPF(username)) {
          //setError("Por favor informe um CPF válido");
          //return;

          setUsername(email)
        }
        if (!email || !email.includes('@')) {
          setError("Por favor informe um e-mail válido");
          return;
        }

        setLoading(true);
        await signUp({ username, email, password: username });
        // await login({ username, password: username });
        await login({ username: email, password: email });
        await restoreSession();
      } catch (err) {
        console.log(err);
      }
    },
    [username, email, restoreSession, login]
  );

  useEffect(() => {
    setError(null);
  }, [username]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    logout();
  }, []);

  return (
    <div className="w-full h-full text-secondary">
      <div
        className=" bg-no-repeat bg-background pt-[40px] pb-[40px]"
        style={{
          backgroundPosition: `left, right`,
          backgroundImage: `url(${bgFlowerLeft}), url(${bgFlowerRight})`,
        }}
      >
        <img src={logo} className="w-1/4 mx-auto block mb-10"  />
      </div>
      <div className="bg-white p-28 w-full h-[79vh]">
        <div className="mx-auto w-[65vw]">
          <h1 className="text-3xl font-bold">Acessar quiz</h1>
          {loading ? (
            <div className="py-6 text-xl font-light flex gap-2 items-center">
              <img src={selo} className="w-16 animate-spin" />
              <span>Carregando...</span>
            </div>
          ) : null}
          {!loading ? (
              <form
                onSubmit={handleSubmit}
                className="flex flex-col items-start gap-2 mt-10"
              >
                {/* <label htmlFor="username">Digite seu CPF</label>
                <input
                  type="text"
                  name="username"
                  placeholder="000.000.000-00"
                  required
                  value={username}
                  onChange={(e) => setUsername(e.target.value.replace(/\D/g, ""))}
                  className="bg-gray-100 p-3 rounded-sm border-b border-b-gray-300 w-full"
                  autoComplete="off"
                />
                {!error ? (
                  <p className="text-gray-400 font-light mb-4">
                    Apenas números e sem pontuação.
                  </p>
                ) : null} */}
                
                <label htmlFor="email" className="mt-4">Digite seu e-mail</label>
                <input
                  type="email"
                  name="email"
                  placeholder="seu@email.com"
                  required
                  value={email}
                  onChange={(e) => {setEmail(e.target.value)}}
                  className="bg-gray-100 p-3 rounded-sm border-b border-b-gray-300 w-full"
                  autoComplete="off"
                />
                {error ? (
                  <p className="text-red-400 font-bold mb-4">{error}</p>
                ) : null}

                

                <Button type="submit" className="text-lg p-6 uppercase mt-10">
                  ENTRAR
                </Button>
              </form>
            ) : null}
        </div>
      </div>
    </div>
  );
}
